<template>
  <div>
    <div class="listening-task border border-info rounded p-2">
      <div
        class="checkListeningTask d-flex justify-content-between align-items-baseline mb-2"
      >
        <b-row>
          <b-col sm="12">
            <div class="d-flex">
              <b-form-checkbox
                class="ml-2"
                v-model="listeningTask.checkListeningTask"
              >
                <p class="btn p-0 m-0 text-info">
                  Listening Task
                </p>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div v-if="listeningTask.checkListeningTask">
              <label>Score:</label>
              <b-form-input
                v-model="listeningTask.scoreForListeningTask"
                placeholder="Enter Score"
                :class="{
                  'form-group-error':
                    $v.listeningTask.scoreForListeningTask.$error,
                }"
              />
              <span
                class="input-error-message"
                v-if="
                  !$v.listeningTask.scoreForListeningTask.required &&
                  $v.listeningTask.scoreForListeningTask.$dirty
                "
              >
                Score is mandatory!
              </span>
            </div>
          </b-col>

          <b-col sm="6">
            <div v-if="listeningTask.checkListeningTask">
              <label>Best of score:</label>
              <b-form-input
                v-model="listeningTask.best_of_scores"
                placeholder="Optional"
                type="number"
                min="0"
              />
              <small class="form-text text-muted">
                Number of best scores will be considered
              </small>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-collapse
        v-model="listeningTask.checkListeningTask"
        class="mt-2"
      >
        <div class="mb-2">
          <span class="font-weight-bolder">
            Choose Score Type:
          </span>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th></th>
              <th>Listening Task</th>
              <th v-if="!activity_simple_calculation">
                Percent Weightage
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="listeningTaskFromApi.length === 0">
              <td colspan="100" class="text-center text-danger">
                No Data Found!
              </td>
            </tr>

            <tr
              v-for="(task, index) in listeningTaskFromApi"
              :key="index"
            >
              <td>
                <b-form-checkbox
                  size="sm"
                  v-model="
                    listeningTaskConfigStructure[task.id].checkbox
                  "
                />
              </td>

              <td>{{ task.name }}</td>

              <td
                v-if="!activity_simple_calculation"
                class="text-center"
              >
                <b-form-input
                  v-if="
                    listeningTaskConfigStructure[task.id].checkbox
                  "
                  placeholder="Enter Percentage"
                  v-model="
                    listeningTaskConfigStructure[task.id].input
                  "
                  @blur="$v.listeningTaskConfigStructure.$each.$touch()"
                />

                <div
                  v-if="
                    listeningTaskConfigStructure[task.id].checkbox &&
                    $v.listeningTaskConfigStructure.$each[task.id]
                      .input.$error
                  "
                  class="text-danger"
                >
                  <span
                    v-if="
                      !$v.listeningTaskConfigStructure.$each[task.id]
                        .input.required
                    "
                  >
                    This field is required.
                  </span>
                  <span
                    v-if="
                      !$v.listeningTaskConfigStructure.$each[task.id]
                        .input.customValidation
                    "
                  >
                    All values must be equal or sum to 100.
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  props: ["saved_configs", "courseReport", "activity_simple_calculation"],

  data() {
    return {
      listeningTask: {
        checkListeningTask: false,
        scoreForListeningTask: 20,
        best_of_scores: "",
      },
      listeningTaskFromApi: [],
      listeningTaskConfigStructure: {},
    };
  },

  async created() {
    await this.getListeningTasks();

    const saved =
      this.saved_configs.activity_catagory_configs.listening_tasks;

    if (saved?.enable) {
      this.listeningTask = {
        checkListeningTask: saved.enable,
        scoreForListeningTask: saved.score,
        best_of_scores: saved.best_of_scores,
      };

      Object.keys(saved.resourses.exam || {}).forEach((key) => {
        if (this.listeningTaskConfigStructure[key]) {
          this.listeningTaskConfigStructure[key].checkbox = true;
          this.listeningTaskConfigStructure[key].input =
            saved.resourses.exam[key].persantage_of_wightage;
        }
      });
    }
  },

  validations: {
    listeningTask: {
      scoreForListeningTask: {
        required: requiredIf(function () {
          return this.listeningTask.checkListeningTask;
        }),
      },
    },

    listeningTaskConfigStructure: {
      $each: {
        input: {
          required() {
            return Object.values(this.listeningTaskConfigStructure).some(
              (c) => c.checkbox
            );
          },

          customValidation() {
            if (
              !this.listeningTask.checkListeningTask ||
              this.activity_simple_calculation
            )
              return true;

            const values = Object.values(
              this.listeningTaskConfigStructure
            )
              .filter((c) => c.checkbox)
              .map((c) => Number(c.input));

            if (!values.length) return true;

            const allSame = values.every(
              (v) => v === values[0]
            );
            const sum100 =
              values.reduce((a, b) => a + b, 0) === 100;

            return allSame || sum100;
          },
        },
      },
    },
  },

  methods: {
    async checkValidation() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    async getListeningTasks() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.courseReport.course_id}/exams`;

      const response = await this.$axios.get(url);

      response.data.forEach((item) => {
        if (item.activity_type === "listening_task") {
          this.$set(this.listeningTaskConfigStructure, item.id, {
            checkbox: false,
            input: "",
          });

          this.listeningTaskFromApi.push({
            id: item.id,
            name: item.name,
            maximum_mark: item.maximum_mark,
            date: item.end_at
              ? moment(item.end_at)
              : null,
          });
        }
      });
    },
  },
};
</script>

<style>
.listening-task p {
  font-size: 16px;
  font-weight: 600;
}
</style>
